export default {
    methods: {
        gotoLeilao (p, target = '_blank') {
            let router = this.$router || this.router
            let routeData = router.resolve({name: 'leiloes.page', params: {id: p.id}})
            window.open(routeData.href, '_blank')
        }
    }
}
